import { render, staticRenderFns } from "./UiTextEdit.vue?vue&type=template&id=23d3378e&"
import script from "./UiTextEdit.vue?vue&type=script&lang=ts&"
export * from "./UiTextEdit.vue?vue&type=script&lang=ts&"
import style0 from "./UiTextEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports